<template>
  <div class="scroll-container" data-mdb-perfect-scrollbar="true" ref="psRef">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import { onMounted, ref } from 'vue';
interface PSProps extends PerfectScrollbar.Options {}
const props = defineProps<PSProps>();
const emit = defineEmits([
  'x-reach-start',
  'x-reach-end',
  'y-reach-start',
  'y-reach-end',
  'scroll-x',
  'scroll-y',
]);
const psRef = ref<HTMLDivElement | null>(null);
const psInstanceRef = ref<PerfectScrollbar>();
onMounted(() => {
  if (psRef.value) {
    const ps = new PerfectScrollbar(psRef.value, { ...props });
    psInstanceRef.value = ps;
    psRef.value.addEventListener('ps-x-reach-start', () => {
      emit('x-reach-start');
    });
    psRef.value.addEventListener('ps-x-reach-end', () => {
      emit('x-reach-end');
    });
    psRef.value.addEventListener('ps-y-reach-start', () => {
      emit('y-reach-start');
    });
    psRef.value.addEventListener('ps-y-reach-end', () => {
      emit('y-reach-end');
    });
    psRef.value.addEventListener('ps-scroll-x', () => {
      emit('scroll-x');
    });
    psRef.value.addEventListener('ps-scroll-y', () => {
      emit('scroll-y');
    });
  }
});

defineExpose({
  psInstance: psInstanceRef,
  psElRef: psRef,
});
</script>

<style scoped></style>
